import { InvalidDataReportStatus, InvalidDataReportType } from "../api/psc";

export const InvalidDataReportTypeInfoList = [
    { id: InvalidDataReportType.WRONG_NUMBER, title: "شماره تماس اشتباه" },
    { id: InvalidDataReportType.WRONG_ADDRESS, title: "آدرس اشتباه" },
    { id: InvalidDataReportType.WRONG_PHASE, title: "مرحله اشتباه" },
];

export const InvalidDataReportStatusInfoList = [
    {
        id: InvalidDataReportStatus.WAITING_FOR_REVIEW,
        title: "در انتظار پاسخ",
        color: "#ff9729",
    },
    {
        id: InvalidDataReportStatus.IN_PROGRESS,
        title: "در حال بررسی",
        color: "#00875a",
    },
    {
        id: InvalidDataReportStatus.ACCEPTED,
        title: "پاسخ داده شده",
        color: "#00875a",
    },
    { id: InvalidDataReportStatus.REJECTED, title: "رد شده", color: "#ff7373" },
];
